//# sourceMappingURL=text.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/text.interface.js
// module id = 1191
// module chunks = 4